import { LayerContainerConfig } from '../../../app/config/model/layercontainer-config.model';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';
import { SERVICE_TYPES } from '../../../app/shared/enum/services-type.enum';

export const LAYER_CONTAINER_CONFIG: LayerContainerConfig = {
  layers: [
    {
      comment: 'Base Map',
      type: 'map-image',
      properties: {
        id: 'none',
        url: '/site/rest/services/Geobasisdienste_PUBLIC/Grenzen/MapServer',
        sublayers: [
          {
            id: 5
          },
        ],
      },
    },
    {
      comment: 'Base Map',
      type: 'map-image',
      properties: {
        id: 'av_webgis_sw_bm',
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/AVWebGIS_sw/Mapserver/',
      },
    },
    {
      comment: 'Base Map',
      type: 'wmts',
      externalService: true,
      properties: {
        id: 'landeskarten',
        url: 'https://wmts.geo.admin.ch/EPSG/2056',
        activeLayer: {
          id: 'ch.swisstopo.pixelkarte-farbe',
          imageFormat: 'image/jpeg',
          tileMatrixSetId: '2056_27',
        },
      },
    },
    {
      comment: 'Base Map',
      type: 'wmts',
      externalService: true,
      properties: {
        id: 'luftbilder',
        url: 'https://wmts.geo.admin.ch/EPSG/2056',
        activeLayer: {
          id: 'ch.swisstopo.swissimage-product',
          imageFormat: 'image/jpeg',
          tileMatrixSetId: '2056_28',
        },
      },
    },
    {
      comment: 'Base Map Layer - Trafi Image - Trafimage_Netzkarte_Relief_2056',
      type: 'wmts',
      externalService: true,
      properties: {
        id: 'trafi_netz',
        url: 'https://tiles.trafimage.ch/wmts',
        activeLayer: {
          id: 'netzkarte_relief_lv95',
          imageFormat: 'image/png',
          tileMatrixSetId: 'swissgrid_lv95',
        },
      },
    },

    {
      comment: 'Base Map',
      type: 'wmts',
      externalService: true,
      properties: {
        id: 'av_farbig',
        url: 'https://wmts.geo.admin.ch/EPSG/2056',
        activeLayer: {
          id: 'ch.kantone.cadastralwebmap-farbe',
          imageFormat: 'image/png',
          tileMatrixSetId: '2056_28',
        },
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.parzellen_view,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.PARZELLEN',
        listMode: 'hide',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.gebaeude,
        url: '/site/rest/services/MDMAMN_PUBLIC/IMMOGIS_V1/MapServer',
        sublayers: [
          {
            id: 12706,
          },
        ],
        title: 'JSON_CONFIG.LAYERLIST.GEBAEUDE',
        listMode: 'hide',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.wms,
      externalService: true,
      properties: {
        id: LayerCode.geo_admin_zonenplan_harmonisiert,
        opacity: 0.5,
        url: 'https://wms.geo.admin.ch/?',
        title: 'JSON_CONFIG.LAYERLIST.ZONENPLAN',
        visible: false,
        sublayers: [
          {
            name: 'ch.are.bauzonen',
            title: 'JSON_CONFIG.LAYERLIST.ZONENPLAN_HARMONISIERT',
            visible: true,
            itemFunctions: [
              {
                id: 'infoLegendZonenplan',
                type: 'panel',
                icon: 'esri-icon-description',
                iconTooltip: 'Legende',
              },
            ],
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.wms,
      externalService: true,
      properties: {
        id: LayerCode.wms_kabelleitungen_swisscom,
        url: 'https://xmlgw.swisscom.ch/geoserver/wms',
        title: 'JSON_CONFIG.LAYERLIST.SWISSCOM_NETZAUSKUNFT',
        visible: false,
        itemFunctions: [
          {
            id: 'infoLegendSwisscom',
            type: 'panel',
            icon: 'esri-icon-description',
            iconTooltip: 'Legende',
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.altlasten,
        url: '/site/rest/services/UMWELT_PUBLIC/Altlasten/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.ALTLASTEN',
        visible: false,
        opacity: 0.5,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.gs_gewaesser,
        url: '/site/rest/services/UMWELT_PUBLIC/GS_Gewaesserschutz/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.GEWAESSERSCHUTZ',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.stoerfallpunkte,
        url: '/site/rest/services/UMWELT_PUBLIC/UW_Stoerfallpunkte/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.STOERFALLPUNKTE',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'Grenzen',
      properties: {
        id: LayerCode.grenzen,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/Grenzen/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.GEMEINDEN',
        visible: false,
        legendEnabled: false,
        sublayers: [
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.PLZ',
          },
          {
            id: 3,
            title: 'JSON_CONFIG.LAYERLIST.Gemeinde',
          },
          {
            id: 4,
            title: 'JSON_CONFIG.LAYERLIST.Ortschaft',
          },
          {
            id: 2,
            title: 'JSON_CONFIG.LAYERLIST.Kanton',
          }
        ]
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.streckennetz,
        url: '/site/rest/services/DGP_PUBLIC/BS_Streckennetz/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.STRECKENNETZ',
        visible: false,
        legendEnabled: false,
        sublayers: [
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.BP',
          },
          {
            id: 1,
            title: 'JSON_CONFIG.LAYERLIST.KZ',
          },
          {
            id: 2,
            title: 'JSON_CONFIG.LAYERLIST.BETRIEBSPUNKT',
            labelsVisible: false,
          },
          {
            id: 3,
            title: 'JSON_CONFIG.LAYERLIST.STRECKE',
            definitionExpression: "LINIENNUMMER like '___'",
          },
          {
            id: 4,
            title: 'JSON_CONFIG.LAYERLIST.METRIERUNG_PUNKT',
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.vector_tile,
      properties: {
        id: LayerCode.av_webgis_sw_vector_tile,
        visible: true,
        title: 'JSON_CONFIG.LAYERLIST.AMTLICHE_VERMESSUNG',
        url: '/portalsite/rest/services/Hosted/AV_sw_LV95/VectorTileServer',
        legendEnabled: false
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.av_webgis_ausland,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/AV_Ausland/Mapserver',
        title: 'JSON_CONFIG.LAYERLIST.AMTLICHE_VERMESSUNG_AUSLAND',
        visible: true,
        legendEnabled: false,
        sublayers: [
          {
            id: 3,
            title: 'JSON_CONFIG.LAYERLIST.LIEGENSCHAFT',
          },
          {
            id: 2,
            title: 'JSON_CONFIG.LAYERLIST.GEBAEUDE',
          },
          {
            id: 1,
            title: 'JSON_CONFIG.LAYERLIST.BESCHRIFTUNG_LIEGENSCHAFT',
          },
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.BESCHRIFTUNG_UEBRIGES',
          }
        ]
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'Bahnplan basic schwarz',
      properties: {
        id: LayerCode.dgp_bahnplan,
        url: '/site/rest/services/DGP_PUBLIC/Bahnplan_schwarz/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.BAHNPLAN_SCHWARZ',
        visible: true,
        legendEnabled: false
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment:
        'IB_Gleisuebergaenge IB_Bruecke_Aufgang_Durchlass IB_Mauern_Waende_Waelle IB_Tunnel ',
      properties: {
        id: LayerCode.dgp_ingenieurbau,
        url: '/site/rest/services/DGP_PUBLIC/IB_Ingenieurbau/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.INGENIEURBAU',
        visible: false,
        legendEnabled: false
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment:
        'Bahnhof_und_Ausruestung',
      properties: {
        id: LayerCode.bahnhof_und_ausruestung,
        url: '/site/rest/services/DGP_PUBLIC/BA_Bahnhof_und_Ausruestung/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.Bahnhof_und_Ausruestung',
        visible: false,
        legendEnabled: false,
        sublayers: [

          {
            id: 4,
            title: 'JSON_CONFIG.LAYERLIST.Verladerampe_Text'
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.Verladerampe',
          },

          {
            id: 12,
            title: 'JSON_CONFIG.LAYERLIST.Strasse'
          }
        ]
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.energie,
        url: '/site/rest/services/DGP_PUBLIC/EE_ELEKTRO_ENERGIE/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.ENERGIE',
        visible: false,
        legendEnabled: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'Leitungskataster für ImmoGIS',
      properties: {
        id: LayerCode.dgp_leitungskataster,
        url: '/site/rest/services/DGP_PUBLIC/Leitungskataster/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.LEITUNGSKATASTER',
        visible: true,
        legendEnabled: false,
        sublayers: [
          {
            id: 23,
            title: 'JSON_CONFIG.LAYERLIST.ABWASSER',
            sublayers: [
              {
                id: 33,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_SPEZIALBAUWERK',
              },
              {
                id: 32,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_SCHACHTFLAECHE',
              },
              {
                id: 31,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_EINLEITSTELLE_BAUWERK',
              },
              {
                id: 30,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_VERSICKERUNGSANLAGE',
              },
              {
                id: 29,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_EINLEITSTELLE_PUNKT',
              },
              {
                id: 28,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_HALTUNG_LEITUNGSRAND',
              },
              {
                id: 27,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_HALTUNG',
              },
              {
                id: 37,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_FLIESSRICHTUNG',
              },
              {
                id: 36,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_BESCHRIFTUNGSBLOCK',
              },
              {
                id: 35,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_BESCHRIFTUNGSLINIE',
              },
              {
                id: 34,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_BESCHRIFTUNG',
              },
              {
                id: 26,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_SCHACHT',
              },
              {
                id: 25,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_DECKEL',
              },
              {
                id: 24,
                title: 'JSON_CONFIG.LAYERLIST.ABWASSER_ABSPERRORGAN',
              },
            ],
          },
          {
            id: 12,
            title: 'JSON_CONFIG.LAYERLIST.WASSER',
            sublayers: [
              {
                id: 22,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_SPEZIALBAUWERK',
              },
              {
                id: 21,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_LEITUNGSRAND',
              },
              {
                id: 20,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_LEITUNG',
              },
              {
                id: 19,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_GEWINNUNGSANLAGE',
              },
              {
                id: 18,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_BEHAELTER',
              },
              {
                id: 17,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_HYDRANT',
              },
              {
                id: 16,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_FOERDERANLAGE',
              },
              {
                id: 15,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_ANLAGE',
              },
              {
                id: 14,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_SPEZIALBAUWERK_DECKEL',
              },
              {
                id: 13,
                title: 'JSON_CONFIG.LAYERLIST.WASSER_ABSPERRORGAN',
              },
            ],
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.TANK',
            sublayers: [
              {
                id: 11,
                title: 'JSON_CONFIG.LAYERLIST.TANK',
              },
              {
                id: 10,
                title: 'JSON_CONFIG.LAYERLIST.TANK_HILFSLINIE',
              },
              {
                id: 9,
                title: 'JSON_CONFIG.LAYERLIST.TANK_LEITUNGSRAND',
              },
              {
                id: 8,
                title: 'JSON_CONFIG.LAYERLIST.TANK_LEITUNG',
              },
              {
                id: 7,
                title: 'JSON_CONFIG.LAYERLIST.TANK_EINSTIEG',
              },
              {
                id: 6,
                title: 'JSON_CONFIG.LAYERLIST.TANK_KNOTEN',
              },
            ],
          },
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.FERNWAERME',
            sublayers: [
              {
                id: 4,
                title: 'JSON_CONFIG.LAYERLIST.FERNWAERMELEITUNG',
              },
              {
                id: 3,
                title: 'JSON_CONFIG.LAYERLIST.FERNWAERME_LEITUNGSRAND',
              },
              {
                id: 2,
                title: 'JSON_CONFIG.LAYERLIST.FERNWAERME_SCHACHT',
              },
              {
                id: 1,
                title: 'JSON_CONFIG.LAYERLIST.FERNWAERMEKNOTEN',
              },
            ],
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'Leitungen Dritter für ImmoGIS',
      properties: {
        id: LayerCode.dgp_leitungendritter,
        url: '/site/rest/services/DGP_PUBLIC/BS_Diverse_Anlagen_Dritter/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.LEITUNGEN_DRITTER',
        visible: true,
        legendEnabled: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: '',
      properties: {
        id: LayerCode.energie_mbul,
        url: '/site/rest/services/ENERGIE_PUBLIC/MBULEnergie/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.ENERGIE_MBUL',
        visible: false,
        legendEnabled: false,
        sublayers: [
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.TRASSE',
          },
          {
            id: 1,
            title: 'JSON_CONFIG.LAYERLIST.ABSCHNITT',
            toolTip: {
              fkLayer: LayerCode.f_public_abschnitt,
            },
          },
          {
            id: 2,
            title: 'JSON_CONFIG.LAYERLIST.ABSCHNITT_SECTIONS',
          },
          {
            id: 3,
            title: 'JSON_CONFIG.LAYERLIST.KNOTEN',
          },
          {
            id: 4,
            title: 'JSON_CONFIG.LAYERLIST.MAST',
            toolTip: {
              fkLayer: LayerCode.f_public_mast,
            },
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.MAST_BEARING',
          },
          {
            id: 6,
            title: 'JSON_CONFIG.LAYERLIST.AUSLEGER',
          },
          {
            id: 7,
            title: 'JSON_CONFIG.LAYERLIST.KABELABSCHNITT',
          },
          {
            id: 8,
            title: 'JSON_CONFIG.LAYERLIST.KABELABSCHNITT_SECTIONS',
          },
          {
            id: 9,
            title: 'JSON_CONFIG.LAYERLIST.KABELPUNKT',
          },
          {
            id: 10,
            title: 'JSON_CONFIG.LAYERLIST.SEIL',
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.sap,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.SAP_OBJEKTE',
        sublayers: [
          {
            id: 13,
            title: 'JSON_CONFIG.LAYERLIST.SAP_REFX_GRUNDSTUECKE',
          },
          {
            id: 12,
            title: 'JSON_CONFIG.LAYERLIST.SAP_REFX_GEBAEUDE',
          },
        ],
      },
    },
    {
      type: 'map-image',
      properties: {
        id: LayerCode.nutzflaeche_infra,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.NUTZFLAECHE_INFRA',
        opacity: 0.5,
        sublayers: [
          {
            id: 7,
            title: 'JSON_CONFIG.LAYERLIST.NUTZFLAECHE',
            toolTip: {
              fkLayer: LayerCode.f_public_nutzflaeche,
            },
            opacity: 0.5,
          },
        ],
      },
    },
    {
      type: 'map-image',
      properties: {
        id: LayerCode.areale_view,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Areale/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.AREALE',
        sublayers: [
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.AREALE'
          },
          {
            id: 1,
            title: 'JSON_CONFIG.LAYERLIST.AREALE_BESCHRIFTUNG'
          },
        ],
      },
    },
    {
      type: 'map-image',
      properties: {
        id: LayerCode.strategieflaeche,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.STRATEGIEFLAECHE',
        sublayers: [
          {
            id: 6,
            title: 'JSON_CONFIG.LAYERLIST.STRATEGIEFLAECHE',
            opacity: 0.5,
            toolTip: {
              fkLayer: LayerCode.f_public_strategieflaeche,
            },
          },
        ],
      },
    },
    {
      type: 'map-image',
      comment: '',
      properties: {
        id: LayerCode.verkaufsobjekte,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/MapServer/',
        title: 'JSON_CONFIG.LAYERLIST.TRANSAKTIONSOBJEKTE',
        visible: false,
        sublayers: [
          {
            id: 10,
            title: 'JSON_CONFIG.LAYERLIST.BAURECHT',
            opacity: 0.5,
            toolTip: {
              fkLayer: LayerCode.f_public_verkaufsobjekte,
            },
          },
          {
            id: 9,
            title: 'JSON_CONFIG.LAYERLIST.LIEGENSCHAFT',
            opacity: 0.5,
            toolTip: {
              fkLayer: LayerCode.f_public_verkaufsobjekte,
            },
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.TRANSAKTIONSOBJEKTE_VERKAUFT',
          },
        ],
      },
    },
    {
      type: 'map-image',
      comment: '',
      properties: {
        id: LayerCode.parzellen,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.PARZELLEN_TEILPARZELLEN',
        visible: false,
        sublayers: [
          {
            id: 3,
            title: 'JSON_CONFIG.LAYERLIST.DRITTPARZELLEN',
            visible: false,
          },
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.PARZELLEN',
           /* toolTip: {
              fkLayer: LayerCode.f_parzellen,
            },*/
          },
          {
            id: 1,
            title: 'JSON_CONFIG.LAYERLIST.TEILPARZELLEN',
            opacity: 0.5,
           /* toolTip: {
              fkLayer: LayerCode.f_teilparzelle,
            },*/
          },
          {
            id: 2,
            title: 'JSON_CONFIG.LAYERLIST.TEILPARZELLE_BESCHRIFTUNG',
            legendEnabled: false,
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.mbul_bauvorhaben,
        title: 'JSON_CONFIG.LAYERLIST.BAUVORHABEN',
        url: '/site/rest/services/ENERGIE_PUBLIC/MBULENERGIE_ZUSATZ/MapServer',
        visible: true,
        opacity: 0.5,
        sublayers: [
          {
            id: 8,
            visible: true,
            title: 'JSON_CONFIG.LAYERLIST.BIS_50',
          },
          {
            id: 7,
            title: 'JSON_CONFIG.LAYERLIST.VORSORGEWERT',
            visible: true,
          },
          {
            id: 6,
            title: 'JSON_CONFIG.LAYERLIST.BIS_20',
            visible: true,
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.BIS_5',
            visible: true,
          },
          {
            id: 9,
            title: 'JSON_CONFIG.LAYERLIST.ABSTAENDE',
            visible: false,
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.av_webgis_sw_liegenschaften,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/Mapserver',
        sublayers: [
          { id: 23, visible: true, title: 'IDENTIFY_CONFIG.PROJEKTIERTE_SELBSTAENDIGE_RECHTE', opacity: 0.01, legendEnabled: false },
          { id: 22, visible: true, title: 'IDENTIFY_CONFIG.PROJEKTIERTE_GRUNDSTUECKE', opacity: 0.01, legendEnabled: false },
          { id: 25, visible: true, title: 'IDENTIFY_CONFIG.SELBSTAENDIGE_RECHTE', opacity: 0.01, legendEnabled: false },
          { id: 24, visible: true, title: 'JSON_CONFIG.LAYERLIST.PARZELLEN', opacity: 0.01, legendEnabled: false },
        ],
        title: 'JSON_CONFIG.LAYERLIST.GRUNDSTUECKE_RECHTE',
        visible: true,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.liegenschaft_grundstuecke,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/Mapserver/24',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.liegenschaften_selbststaendige_rechte,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/Mapserver/25',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'needed for search Parzelle SBB',
      properties: {
        id: LayerCode.map_parzelle,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/MapServer/0',
        title: 'JSON_CONFIG.LAYERLIST.PARZELLEN_MAP',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      comment: 'needed for search Parzelle CH',
      properties: {
        id: LayerCode.av_webgis_sw_liegenschaftenNr,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/Mapserver/24',
        title: 'JSON_CONFIG.LAYERLIST.PARZELLEN_CH',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.p_verkaufsobjekte,
        url: '/site/rest/services/IMMOBILIEN/Verkaufsobjekte_Edit/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.TRANSAKTIONSOBJEKTE',
        visible: false,
      },
    },
    {
      comment: 'ISBA Denkmalpflege Reports',
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.denkmalpflege,
        url: '/site/rest/services/DENKMALPFLEGE_PUBLIC/ISBA_REPORTS/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.DENKMALPFLEGE',
        visible: false,
        sublayers: [
          {
            id: 4,
            title: 'JSON_CONFIG.LAYERLIST.ENSEMBLE',
          },
          {
            id: 20,
            title: 'JSON_CONFIG.LAYERLIST.EO',
          },
          {
            id: 40,
            title: 'JSON_CONFIG.LAYERLIST.KUNSTOBJEKT',
          },
          {
            id: 5,
            title: 'JSON_CONFIG.LAYERLIST.EINZELOBJEKT_EINGESTUFT',
          },
        ],
      },
    },
    {
      comment: 'ISBA ISOS',
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.isos,
        url: '/site/rest/services/DENKMALPFLEGE_PUBLIC/ISBA_ISOS/MapServer',
        title: 'JSON_CONFIG.LAYERLIST.DENKMALPFLEGE_ISOS',
        visible: true,
        sublayers: [
          {
            id: 0,
            title: 'JSON_CONFIG.LAYERLIST.ISOS_BUNDES',
          },
        ],
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.map_Kilometrierung,
        url: '/site/rest/services/DGP_PUBLIC/BS_Streckennetz/MapServer/3',
        title: 'JSON_CONFIG.LAYERLIST.KILOMETRIERUNG_MAP',
        DefinitionExpression: 'kilometrierungslinie_nummer<999',
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.map_Hektometer,
        url: '/site/rest/services/DGP_PUBLIC/netzelemente/MapServer/43',
        title: 'JSON_CONFIG.LAYERLIST.HEKTOMETER_MAP',
        definitionExpression: `kilometrierungslinie_nummer<999`,
        visible: false,
      },
    },
    {
      type: SERVICE_TYPES.map_image,
      properties: {
        id: LayerCode.lineinfo,
        url: '/site/rest/services/DGP_PUBLIC/netzelemente/MapServer',
      },
      extension: '/exts/DGP_Streckenbezug/getStreckenForGeometry',
    },

    /// FeatureLayers ////////////////////////////////////////////////////////////////////////////
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_liegenschaften_proj_grundstuecke,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/FeatureServer/22',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_liegenschaften_proj_selbst_rechte,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/FeatureServer/23',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_parzellen,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/FeatureServer/0',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_parzelleDritt,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/FeatureServer/3',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_isba_eo_report,
        url: '/site/rest/services/DENKMALPFLEGE_PUBLIC/ISBA_REPORTS/FeatureServer/5',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_isba_ko_report,
        url: '/site/rest/services/DENKMALPFLEGE_PUBLIC/ISBA_REPORTS/FeatureServer/40',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_gebaeude,
        url: '/site/rest/services/MDMAMN_PUBLIC/IMMOGIS_V1/FeatureServer/12706',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_parzelle_Locate_view,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Immobilien_Locate_Views/FeatureServer/0',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_teilparzelle_Locate_view,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Immobilien_Locate_Views/FeatureServer/1',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_teilparzelle,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Parzellen/FeatureServer/1',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_verkaufsobjekte,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/9',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_strategieflaeche,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/6',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_nutzflaeche,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/7',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0.5,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_areale,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/Areale/FeatureServer/0',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_verkaufsobjekte,
        title: 'Transaktionsobjekt',
        url: '/site/rest/services/IMMOBILIEN/Verkaufsobjekte_Edit/FeatureServer/0',
        geometryType: 'polygon',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_sap_mietertraege,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/2',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_refx_gb,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/12',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_refx_gr,
        url: '/site/rest/services/IMMOBILIEN_PUBLIC/ImmobilienZusatz/FeatureServer/13',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      comment: 'ENERGIE Feature Class Mast',
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_mast,
        url: '/site/rest/services/ENERGIE_PUBLIC/MBULEnergie/FeatureServer/4',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      comment: 'ENERGIE Feature Class Abschnitt',
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_abschnitt,
        url: '/site/rest/services/ENERGIE_PUBLIC/MBULEnergie/FeatureServer/1',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      comment: 'ENERGIE Feature Class Trasse',
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_trasse,
        url: '/site/rest/services/ENERGIE_PUBLIC/MBULEnergie/FeatureServer/0',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      comment: 'UMWELT Feature Class Altlasten Standort',
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_public_altlasten_standort,
        url: '/site/rest/services/UMWELT_PUBLIC/Altlasten/FeatureServer/2',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0.5,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_liegenschaft_grundstuecke,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/FeatureServer/24',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      properties: {
        id: LayerCode.f_liegenschaften_selbststaendige_rechte,
        url: '/site/rest/services/Geobasisdienste_PUBLIC/AVSchweiz_sw/FeatureServer/25',
        visible: false,
        listMode: 'hide',
        labelsVisible: false,
        legendEnabled: false,
        outFields: ['*'],
        opacity: 0,
      },
    },
    {
      type: SERVICE_TYPES.feature,
      comment: 'Used in Search Tool & Arbeitsbereich ISBA detailview',
      properties: {
        id: LayerCode.f_betriebspunkt,
        url: '/site/rest/services/DGP_PUBLIC/netzelemente/FeatureServer/45',
        legendEnabled: false,
      },
    },
  ],
};
